import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:     {
    company: null,
    dubbingActor: null,
    coreDataSubmission: null
  },
  getters:   {
    company(state) {
      return state.company
    },
    dubbingActor(state) {
      return state.dubbingActor
    },
    coreDataSubmission(state) {
      return state.coreDataSubmission
    }
  },
  mutations: {
    initialiseStore(state) {
      let company = JSON.parse(localStorage.getItem('company'))
      if (company) {
        state.company = company
      }
    },
    setCompany(state, company) {
      localStorage.setItem('company', JSON.stringify(company));
      state.company = company
    },
    setDubbingActor(state, dubbingActor) {
      state.dubbingActor = dubbingActor
    },
    setCoreDataSubmission(state, coreDataSubmission) {
      state.coreDataSubmission = coreDataSubmission
    }
  },
  actions:   {
    selectCompany({commit}, company) {
      commit("setCompany", company)
    },
    selectDubbingActor({commit}, dubbingActor) {
      commit("setDubbingActor", dubbingActor)
    },
    setCoreDataSubmission({commit}, coreDataSubmission) {
      commit("setCoreDataSubmission", coreDataSubmission)
    }
  },
  modules:   {}
})